import { Fragment, useState, useEffect } from "react"
import {
  Row
} from "reactstrap"
import BodyMidTop from "./TabBodyMid/BodyMidTop"

const BodyMid = ({ statusInstruments }) => {
  const [statusInstrumentData, setStatusInstrumentData] = useState([])

  useEffect(() => {
    setStatusInstrumentData(statusInstruments)
  }, [statusInstruments])


  return (
    <Fragment>
      <Row>
        <BodyMidTop statusInstruments={statusInstrumentData} />
        {/* <BodyMidBottom /> */}
      </Row>
    </Fragment>
  )
}

export default BodyMid
